import './App.css';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// MSAL imports
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import ReadFlights from './components/ReadFlights';
import FlightNotes from './components/FlightNotes';
import FlightGraphs from './components/FlightGraphs';
import WritePage from './components/WritePage';
import TemplatesPage from './components/TemplatesPage';
import Visualise from './components/Visualise';
import Product from './components/Product';
import Navbar from './components/Navbar';
import ReconnectPrompt from './components/ReconnectPrompt';

// This component will hold the main application content for authenticated users
function AppContent() {
  return (
    <Router>
      <Navbar /> {/* We will enhance Navbar later for logout and user display */}
      <header className="App-header">
        <Routes>
          <Route path="/flight_tracker/read" element={<ReadFlights />} />
          <Route path="/flight_tracker/flight_notes" element={<FlightNotes />} />
          <Route path="/flight_tracker/graphs" element={<FlightGraphs />} />
          <Route path="/flight_tracker/write" element={<WritePage />} />
          <Route path="/flight_tracker/templates" element={<TemplatesPage />} />
          <Route path="/flight_tracker/visualise" element={<Visualise />} />
          <Route path="/products" element={<Product />} />
          <Route path="/" element={<Navigate to="/flight_tracker/graphs" replace />} /> {/* Content for home page can be added here instead if needed in the future */}
        </Routes>
      </header>
    </Router>
  );
}

function App() {
  const { instance } = useMsal(); // Get MSAL instance

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
        console.error("Login redirect failed: ", e);
    });
  }

  return (
    <div className="App">
      <AuthenticatedTemplate>
        <ReconnectPrompt />
        <AppContent />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center' }}>
          <h1>Cambridge Aerospace</h1>
          <p>Please log in to accesss tooling.</p>
          <button onClick={handleLogin} style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', marginTop: '20px' }}>
            Login with Microsoft
          </button>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
